import { Grid, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import MultipleSelect from "../../components/Comman/MultipleSelect";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { titleColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  atleastOne,
  beatSelectMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
  updateData,
  updateMsg,
  vehicleRequiredMsg,
  vehicleSelectMsg,
} from "../../config/messageconstant";
import { ChallanJson } from "../../DynamicFormsJson/MastersJSON/challan";
import {
  getAreaByTalukaPostBody,
  getAreaByUserType,
} from "../../Slice/area.slice";
import { getBeatBySalesTeamIdAndAreaIdPost } from "../../Slice/beat.slice";
import { setCategoryAndItemForChallan } from "../../Slice/category.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getRegionNew } from "../../Slice/region.slice";
import {
  getDriversByStockHolderId,
  getSalesExecutiveByAreaId,
} from "../../Slice/salesExecutive.slice";
import { getStockholderByAreaIdsForFilter } from "../../Slice/StackHolder.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import {
  getSelfAssignedOrNotAssignedOverallVehicleAndBeats,
  getSelfAssignedOrNotAssignedOverallVehicleAndBeatsNew,
} from "../../Slice/veichleSlice.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import ChallanFormProductTable from "./ChallanFormProductTable";
import NewMultipleSelect from "../../components/Comman/NewMultipleSelect";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

class ChallanForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      beatAssignList: [],
      salesTeamId: "",
      adminFlag: false,
      stockHolderId: "",
      stockFlag: false,
      searchValue: "",
      value: 0,
      total: 0,
      totalOfQty: 0,
      orderList: [],
      vehicleId: "",
      beatIds: [],
      vehicleNo: "",
      beatName: "",
      driverId: "",
      fieldData: {},
      date: "",
      transferNo: "",
      selectedAreaIds: [],
      availableBeatList: [],
      beatListNew: [],
      apiBeatList: [],
      beatIdsToStore: [],
      dynamicMasterData: {
        areaDetail: this.props.areaList.area,
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        stockHolderDetail: this.props.stockHolderList?.stockholderByArea,
        driverDetail: this.props.driverList?.driverByStockHolder,
      },
    };
  }
  async componentDidMount() {
    const {
      setCategoryAndItemForChallan,
      getRegionNew,
      getAreaByUserType,
      showLoador,
      showNotification,
    } = this.props;

    if (navigator.onLine) {
      setCategoryAndItemForChallan({ row: [] });

      if (this.props.params.id) {
        this.getDataById(this.props.params.id);
      } else {
        const userTypeId = localStorage.getItem("userTypeId");

        if (userTypeId == 1 || userTypeId == 6) {
          showLoador({ loador: true });
          getRegionNew().then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });

          this.setState({
            adminFlag: true,
          });
        } else {
          showLoador({ loador: true });
          getAreaByUserType().then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  getDataById = async (id) => {
    const {
      getSelfAssignedOrNotAssignedOverallVehicleAndBeatsNew,
      showLoador,
    } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      const response = await apiGet({
        url: endpoint.vanStockTransferHeader + "/" + id,
      }).then(async ({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (!data.error) {
            let rowData = data.data;
            let stockHolderId =
              rowData.stockStakeHolderId !== null
                ? rowData.stockStakeHolderId
                : "";

            this.setState({
              fieldData: rowData,
              transferNo: rowData.transferNo !== null ? rowData.transferNo : "",
              stockHolderId,
              date: rowData.date !== null ? rowData.date : "",
              vehicleId: rowData.vehicleId !== null ? rowData.vehicleId : "",
              driverId: rowData.driverId !== null ? rowData.driverId : "",

              DataToSet: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Transfer No",
                  value: rowData.transferNo !== null ? rowData.transferNo : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Date",
                  value: rowData.date !== null ? rowData.date : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Stock Holder",
                  value:
                    rowData.firmName !== null &&
                      rowData.stockStakeHolderTypePrefix !== null
                      ? rowData.firmName +
                      " (" +
                      rowData.stockStakeHolderTypePrefix +
                      ") "
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Driver Name",
                  value: rowData.driverName !== null ? rowData.driverName : "",
                },
              ],
            });

            await getSelfAssignedOrNotAssignedOverallVehicleAndBeatsNew({
              driverId: rowData.driverId,
              vanStockTransferHeaderId: id,
            }).then(({ response, success }) => {
              showLoador({ loador: false });

              if (success && response?.beatList) {
                const availableBeats = response.beatList;

                const preSelectedBeatIds = (rowData.beatList || [])
                  .map((b) => b.beatId)
                  .filter(Boolean);

                this.setState({
                  beatListNew: availableBeats,
                  beatIds: preSelectedBeatIds,
                  beatIdsToStore: preSelectedBeatIds,
                });
              } else {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            });

            showLoador({ loador: true });
            await apiGet({
              url:
                endpoint.categoryLatest +
                "/and-items-with-margin-and-mrp-by-stock-stake-holder?stockStakeHolderId=" +
                stockHolderId,
            }).then(({ data, success }) => {
              showLoador({ loador: false });
              if (success && data.data != null) {
                const rowItemData = data.data;
                if (rowItemData.errorMessage.error) {
                  showNotification({
                    msg: rowItemData.errorMessage.message,
                    severity: "error",
                  });
                } else {
                  let row = [];
                  const stockCalAtBill = localStorage.getItem("stockCalAtBill");
                  this.setState({
                    stockFlag: stockCalAtBill === "1" ? true : false,
                  });
                  if (stockCalAtBill === "1") {
                    row = rowItemData.categoryAndItems.map(
                      (categoryProducObject) => {
                        return {
                          ...categoryProducObject,
                          total: 0,
                          qty: 0,
                          productWithMarginAndMrps:
                            categoryProducObject.productWithMarginAndMrps.map(
                              (product) => {
                                const matchedTransfer =
                                  rowData.vanStockTransferDetail.find(
                                    (item) =>
                                      item.productId === product.products.id
                                  );

                                let primaryQtyForEditTable = matchedTransfer
                                  ? Math.floor(matchedTransfer.primaryQty)
                                  : "";
                                let secondaryQtyForEditTable = matchedTransfer
                                  ? matchedTransfer.secondaryQty %
                                  matchedTransfer.conversionValue
                                  : "";

                                let rate = matchedTransfer
                                  ? matchedTransfer.rate
                                  : product.rate;

                                return {
                                  ...product,
                                  mrp: product.mrp,
                                  rate: rate,
                                  rateForEdit: product.rate,
                                  primaryClosingQty:
                                    product.productStockForMobile.primaryClosingQty.toFixed(
                                      2
                                    ),
                                  secondaryClosingQty:
                                    product.productStockForMobile.secondaryClosingQty.toFixed(
                                      2
                                    ),
                                  primaryQty: primaryQtyForEditTable,
                                  secondaryQty: secondaryQtyForEditTable,
                                  qty: 0,
                                  freeQty: 0,
                                  itemDiscPer: 0,
                                  total: 0,
                                  totalQty: 0,
                                };
                              }
                            ),
                        };
                      }
                    );

                    this.setCatList({ row });
                  } else {
                    row = rowItemData.categoryAndItems.map((rowObj) => {
                      return {
                        ...rowObj,
                        total: 0,
                        qty: 0,
                        productWithMarginAndMrps:
                          categoryProducObject.productWithMarginAndMrps.map(
                            (product) => {
                              const matchedTransfer =
                                rowData.vanStockTransferDetail.find(
                                  (item) =>
                                    item.productId === product.products.id
                                );

                              let primaryQtyForEditTable = matchedTransfer
                                ? Math.floor(matchedTransfer.primaryQty)
                                : "";
                              let secondaryQtyForEditTable = matchedTransfer
                                ? matchedTransfer.secondaryQty %
                                matchedTransfer.conversionValue
                                : "";

                              let rate = matchedTransfer
                                ? matchedTransfer.rate
                                : product.rate;
                              return {
                                ...product,
                                rate: rate,
                                mrp: product.mrp,
                                rateForEdit: product.rate,
                                uomConversionValue:
                                  product.products.uomConversionValue,
                                qty: 0,
                                freeQty: 0,
                                itemDiscPer: 0,
                                total: 0,
                                primaryQty: primaryQtyForEditTable,
                                secondaryQty: secondaryQtyForEditTable,
                                totalQty: 0,
                              };
                            }
                          ),
                      };
                    });
                    this.setCatList({ row });
                  }
                }
              } else {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            });

            return { data: rowData, success };
          }
          return { data: {}, success: false };
        }

        return { data: {}, success: false };
      });
      return response;
    } else {
      this.props.showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.area,
          },
        });
      }
    }

    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.stockHolderList !== nextProps.stockHolderList) {
      if (
        this.props.stockHolderList?.stockholderByArea !==
        nextProps.stockHolderList?.stockholderByArea
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderDetail: nextProps.stockHolderList?.stockholderByArea,
          },
        });
      }
    }
    if (this.props.driverList !== nextProps.driverList) {
      if (
        this.props.driverList?.driverByStockHolder !==
        nextProps.driverList?.driverByStockHolder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            driverDetail: nextProps.driverList?.driverByStockHolder,
          },
        });
      }
    }
  }

  setCatList = ({ row }) => {
    const { setCategoryAndItemForChallan } = this.props;
    let dataTotal = 0;
    let totalofTotalQty = 0;
    row.map((rowData) => {
      if (rowData.flag == 3) {
        rowData.productWithMarginAndMrps.map((productData) => {
          dataTotal =
            dataTotal +
            (+productData.primaryQty * productData.products.uomConversionValue +
              +productData.secondaryQty) *
            (+productData.rate);
          totalofTotalQty =
            totalofTotalQty +
            +productData.primaryQty * productData.products.uomConversionValue +
            +productData.secondaryQty;
        });
      }
    });

    this.setState({ total: dataTotal, totalOfQty: totalofTotalQty });
    setCategoryAndItemForChallan({ row });
  };

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBody,
      getStockholderByAreaIdsForFilter,
      getDriversByStockHolderId,
      getSelfAssignedOrNotAssignedOverallVehicleAndBeats,
      showLoador,
      showNotification,
    } = this.props;

    if (data.area) {
      this.setState({ selectedAreaIds: data.area });
    }

    const { stockHolderId } = this.state;
    if (navigator.onLine) {
      this.setState({
        vehicleNo: "",
        beatName: "",
      });

      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaJson = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBody({ talukaIds: talukaJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }

      if (this.state.adminFlag) {
        if (data.area && data.area != "") {
          this.setState({ selectedAreaIds: data?.area });

          showLoador({ loador: true });
          await getStockholderByAreaIdsForFilter({ areaIds: data.area }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        }
        if (data.stockHolder && data.stockHolder != "") {
          this.setState({ stockHolderId: data.stockHolder });

          let selectedAreaIds = this.state.selectedAreaIds;

          let areaIdsObj = {
            areaIds: selectedAreaIds,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: data.stockHolder,
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      } else {
        if (data.area && data.area != "") {
          let stockHolderId = localStorage.getItem("userId");

          this.setState({ stockHolderId: stockHolderId });

          let areaIdsObj = {
            areaIds: data.area,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: "",
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }

      if (data.driver && data.driver !== "") {
        const areaIds = { areaIds: data.area };

        showLoador({ loador: true });
        await getSelfAssignedOrNotAssignedOverallVehicleAndBeats({
          driverId: data.driver,
          areaIds,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      if (data.driver && data.driver !== "") {
        let vehicleNotAssignedFlag = false;
        this.setState({ driverId: data.driver });
        let dateForAPI = dayjs().format("DD-MM-YYYY");

        showLoador({ loador: true });
        await apiGet({
          url:
            endpoint.vehicle +
            "/assign-date-wise?driverId=" +
            data.driver +
            "&date=" +
            dateForAPI,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            if (data && data.data && Object.keys(data.data).length !== 0) {
              let vehicleId = data.data.id !== null ? data.data.id : "";
              let vehicleNo =
                data.data.vehicleNo !== null ? data.data.vehicleNo : "-";
              let beatList = data.data.beatList.map((dataObj, index) => {
                return {
                  index: index + 1,
                  id: dataObj.beatId !== null ? dataObj.beatId : "",
                  name: dataObj.beatName !== null ? dataObj.beatName : "",
                };
              });
              let beatName =
                data.data.beatList.length !== 0
                  ? data.data.beatList
                    .map((item) => item.beatName.trim())
                    .join(", ")
                  : "-";
              let beatIds =
                data.data.beatList.length !== 0
                  ? data.data.beatList.map((item) => item.beatId)
                  : "";

              let beatIdsToStore =
                data.data.beatList.length !== 0
                  ? data.data.beatList.map((item) => item.beatId)
                  : "";

              this.setState({
                vehicleId,
                beatIds,
                beatIdsToStore,
                vehicleNo,
                beatName,
                apiBeatList: beatList,
              });
            } else {
              this.props.setCategoryAndItemForChallan({ row: [] });
              vehicleNotAssignedFlag = true;
              showNotification({
                msg: "Vehicle not assigned for driver",
                severity: "error",
              });
            }
          } else {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        if (!vehicleNotAssignedFlag) {
          showLoador({ loador: true });
          await apiGet({
            url:
              endpoint.categoryLatest +
              "/and-items-with-margin-and-mrp-by-stock-stake-holder?stockStakeHolderId=" +
              stockHolderId,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (success && data.data != null) {
              const rowItemData = data.data;
              if (rowItemData.errorMessage.error) {
                showNotification({
                  msg: rowItemData.errorMessage.message,
                  severity: "error",
                });
              } else {
                let row = [];
                const stockCalAtBill = localStorage.getItem("stockCalAtBill");
                this.setState({
                  stockFlag: stockCalAtBill === "1" ? true : false,
                });
                if (stockCalAtBill === "1") {
                  row = rowItemData.categoryAndItems.map(
                    (categoryProducObject) => {
                      let rowData = [];
                      let i;
                      let j;
                      let rsLength =
                        categoryProducObject.productWithMarginAndMrps.length;
                      for (i = 0; i < rsLength; i++) {
                        let orderObject = {
                          ...categoryProducObject.productWithMarginAndMrps[i],
                          rate: categoryProducObject.productWithMarginAndMrps[i]
                            .rate,
                          rateForEdit: categoryProducObject.productWithMarginAndMrps[i]
                            .rate,
                          mrp: categoryProducObject.productWithMarginAndMrps[i].mrp,
                          primaryClosingQty:
                            categoryProducObject.productWithMarginAndMrps[
                              i
                            ].productStockForMobile.primaryClosingQty.toFixed(
                              2
                            ),
                          secondaryClosingQty:
                            categoryProducObject.productWithMarginAndMrps[
                              i
                            ].productStockForMobile.secondaryClosingQty.toFixed(
                              2
                            ),
                          qty: "",
                          freeQty: 0,
                          itemDiscPer: 0,
                          total: 0,
                          primaryQty: "",
                          secondaryQty: "",
                          totalQty: 0,
                        };
                        rowData.push(orderObject);
                      }
                      return {
                        ...categoryProducObject,
                        total: "",
                        qty: 0,
                        productWithMarginAndMrps: rowData,
                      };
                    }
                  );
                  this.setCatList({ row });
                } else {
                  row = rowItemData.categoryAndItems.map((rowObj) => {
                    return {
                      ...rowObj,
                      total: 0,
                      qty: 0,
                      productWithMarginAndMrps:
                        rowObj.productWithMarginAndMrps.map((product) => {
                          return {
                            ...product,
                            mrp: product.mrp,
                            rateForEdit: product.rate,
                            uomConversionValue:
                              product.products.uomConversionValue,
                            qty: 0,
                            freeQty: 0,
                            itemDiscPer: 0,
                            total: 0,
                            primaryQty: "",
                            secondaryQty: "",
                            totalQty: 0,
                          };
                        }),
                    };
                  });
                  this.setCatList({ row });
                }
              }
            } else {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  submitHandler = () => {
    const { category, vehicleList } = this.props;
    const {
      stockHolderId,
      vehicleId,
      driverId,
      date,
      transferNo,
      beatIds,
      beatListNew,
      beatIdsToStore,
    } = this.state;

    let beatList = [];

    if (this.props.params.id) {
      beatList =
        beatListNew.length > 0
          ? beatListNew
            .filter((beat) => beatIdsToStore.includes(beat.beatId))
            .map((beat) => ({
              beatId: beat.beatId,
              beatName: beat.beatName,
            }))
          : [];
    } else {
      beatList =
        beatIdsToStore?.length > 0
          ? beatIdsToStore.map((id) => {
            const beat = (vehicleList?.vehicleBeat?.beatList || []).find(
              (b) => b.id === id
            );

            return {
              beatId: beat?.id || "",
              beatName: beat?.beatName || "",
            };
          })
          : [];
    }

    if (vehicleId == null || vehicleId === "") {
      this.props.showNotification({
        msg: vehicleRequiredMsg,
        severity: "error",
      });
      return;
    }

    if (!beatList.length) {
      this.props.showNotification({
        msg: beatSelectMsg,
        severity: "error",
      });
      return;
    }


    if (!vehicleList?.vehicleBeat?.vehicleList?.length) {
      this.props.showNotification({
        msg: vehicleSelectMsg,
        severity: "error",
      });
      return;
    }

    let dateForSubmit = this.props.params.id
      ? date
      : dayjs().format("DD-MM-YYYY");

    let rowList = [];

    let dataJson = {};

    let isQtyError = false;

    category.category.map((catData) => {
      if (catData.flag == 3) {
        const filterData = catData.productWithMarginAndMrps.filter(
          (row) => row.totalQty != 0
        );
        rowList = [...rowList, ...filterData];
        return catData;
      }
    });

    if (rowList.length != 0) {
      isQtyError = rowList.some((obj) => obj.qtyError);

      const orderList = rowList.map((rowData, index) => {
        let uomConversionValue =
          rowData.products !== null &&
            rowData.products.uomConversionValue !== null
            ? rowData.products.uomConversionValue
            : "";

        return {
          index: index + 1,
          stockStakeHolder: { id: stockHolderId },
          date: dateForSubmit,
          rate: rowData.rate,
          mrp: rowData.mrp,
          product: {
            id: rowData.products !== null ? rowData.products.id : "",
          },
          primaryQty: rowData.totalQty / uomConversionValue,
          secondaryQty: rowData.totalQty,
        };
      });

      if (this.props.params.id) {
        dataJson = {
          id: this.props.params.id,
          transferNo: transferNo,
          stockStakeHolder: { id: stockHolderId },
          date: dateForSubmit,
          driver: { id: driverId },
          vehicle: { id: vehicleId },
          status: 0,
          vanStockTransferDetail: orderList,
          beatList: beatList,
        };
      } else {
        dataJson = {
          stockStakeHolder: { id: stockHolderId },
          date: dateForSubmit,
          driver: { id: driverId },
          vehicle: { id: vehicleId },
          status: 0,
          vanStockTransferDetail: orderList,
          beatList: beatList,
        };
      }

      if (isQtyError) {
        this.props.showNotification({
          msg: "Quantity should be less than product stock",
          severity: "error",
        });
      } else {
        this.onSubmit(dataJson);
      }
    } else {
      this.props.showNotification({ msg: atleastOne, severity: "error" });
    }
  };

  onSubmit = (dataJson) => {
    const { showLoador, showNotification } = this.props;

    console.log("Data to submit", dataJson);

    if (navigator.onLine) {
      swal({
        title: "Are you sure?",
        text: this.props.params.id ? updateData : saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          showLoador({ loador: true });
          apiPost({
            url: this.props.params.id
              ? endpoint.vanStockTransferHeader + "/edit"
              : endpoint.vanStockTransferHeader,
            postBody: dataJson,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (success) {
              showNotification({
                msg: this.props.params.id ? updateMsg : savemsg,
              });
              this.props.navigate(-1);
            } else {
              showNotification({
                msg: saveFailedMsg,
                severity: "error",
              });
            }
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchValue = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableData = (tableData) => {
    const { searchValue } = this.state;
    return tableData.filter((currentRow) => {
      let isValid = false;
      let productName =
        currentRow.products != null ? currentRow.products.name : "-";
      let stakeHolderUom =
        currentRow.products.stakeHolderUom != null
          ? currentRow.products.stakeHolderUom.name
          : "-";
      if (
        productName &&
        productName
          .toString()
          .toLowerCase()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        stakeHolderUom &&
        stakeHolderUom
          .toString()
          .toLowerCase()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      return isValid;
    });
  };

  changeHandler = (e, value) => {
    this.setState({ vehicleId: value });
  };

  multiSelectHandler = (value, name) => {
    const { vehicleList } = this.props;
    const beatList = vehicleList?.vehicleBeat?.beatList || [];

    const allIds = beatList.map((data) => data.id);
    let updatedValue = [...value];

    const isAllSelected = updatedValue.includes("all");
    const wasAllPreviouslySelected = this.state.beatIds.includes("all");

    if (name === "beat") {
      // CASE 1: "All" is newly selected
      if (isAllSelected && !wasAllPreviouslySelected) {
        this.setState({
          beatIds: ["all"],
          beatIdsToStore: allIds,
        });
      }

      //CASE 2: "All" was previously selected, and user clicked an individual beat
      else if (wasAllPreviouslySelected) {
        // Find which beat was clicked
        const newlyClicked = updatedValue.find((id) => id !== "all");

        // Remove clicked one from all list
        const remainingIds = allIds.filter((id) => id !== newlyClicked);

        this.setState({
          beatIds: remainingIds,
          beatIdsToStore: remainingIds,
        });
      }

      //CASE 3: Normal multiselect behavior (no "All" involved)
      else {
        updatedValue = updatedValue.filter((id) => id !== "all");
        this.setState({
          beatIds: updatedValue,
          beatIdsToStore: updatedValue,
        });
      }
    }
  };

  render() {
    const {
      matrixData,
      dynamicMasterData,
      DataToSet,
      dayList,
      adminFlag,
      stockFlag,
      value,
      totalOfQty,
      total,
      vehicleId,
      driverId,
      vehicleNo,
      beatName,
      beatIds,
      beatListNew,
      apiBeatList,
      beatIdsToStore,
    } = this.state;
    const { category, vehicleList } = this.props;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showSaveBtn={ChallanJson.showSaveBtn}
            showTitle={ChallanJson.showTitle}
            screenTitle={ChallanJson.screenTitle}
            fieldMeta={
              this.props.params.id
                ? []
                : adminFlag
                  ? ChallanJson.fieldMeta
                  : ChallanJson.fieldMetaForStockHolder
            }
            showCancel={ChallanJson.showCancel}
            apiBaseURL={ChallanJson.apiBaseURL}
            showSaveNextBtn={false}
            saveBtnText={""}
            showSaveBtnMain={false}
            getListById={this.getListById}
            onSave={this.onSearchValue}
          />

          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              sm={6}
              xs={12}
              md={6}
              lg={6}
              container
              alignItems="center"
              justifyContent="space-between"
            >
              {/* Label on left */}
              <Grid item xs="auto">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: "red" }}
                    label="* "
                  />
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: titleColor }}
                    label="Vehicle:"
                  />
                </div>
              </Grid>

              {/* AutoComplete aligned right, full width inside */}
              <Grid
                item
                xs
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Grid item xs={8.9}>
                  {" "}
                  {/* adjust size here */}
                  <AutoComplete
                    keyColName={"id"}
                    placeHolder="Select Vehicle"
                    value={vehicleId}
                    name={"vehicleNo"}
                    options={
                      this.props.vehicleList?.vehicleBeat?.vehicleList || []
                    }
                    onChange={this.changeHandler}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              sm={6}
              xs={12}
              md={6}
              lg={6}
              container
              alignItems="center"
              justifyContent="space-between"
            >
              {/* Label on left */}
              <Grid item xs="auto">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: "red" }}
                    label="* "
                  />
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: titleColor }}
                    label="Beat:"
                  />
                </div>
              </Grid>

              {/* AutoComplete aligned right, full width inside */}

              <Grid
                item
                xs
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Grid item xs={8.7}>
                  <NewMultipleSelect
                    label={"Select Beat"}
                    name1="beat"
                    value1={beatIds}
                    names={[
                      { id: "all", name: "All" },
                      ...(vehicleList?.vehicleBeat?.beatList || []),
                    ]}
                    onChange={this.multiSelectHandler}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {category.category.length != 0 && (
            <>
              <Tabs
                value={value}
                onChange={this.handleChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                aria-label="scrollable force tabs example"
              >
                {category.category.map((catData) => {
                  return (
                    <Tab
                      label={
                        catData.category.name +
                        " ( " +
                        catData.productWithMarginAndMrps.length +
                        " )"
                      }
                    />
                  );
                })}
              </Tabs>
              {category.category.map((catData, index) => {
                return (
                  <TabPanel value={value} index={index}>
                    <LandingScreenHeader
                      screenTitle={""}
                      showSearchBox={true}
                      showTable={true}
                      showFilter={false}
                      showPdfDownload={false}
                      showExcelDownload={false}
                      onSearch={this.onSearchValue}
                    />
                    <ChallanFormProductTable
                      tableHead={[
                        {
                          title: "Sr.No.",
                          name: "index",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "center",
                        },
                        {
                          title: "Product Name",
                          name: "name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                        },
                        {
                          title: "UOM",
                          name: "name",
                          positionCenter: true,
                          showInscreen: true,
                        },
                        {
                          title: "Rate",
                          name: "name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                        },
                        {
                          title: "Stock",
                          name: "primaryClosingQty",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                        },
                        {
                          title: "Primary Qty",
                          name: "target",
                          placeHolder: "Enter Target",
                          textFieldError: "targetErr",
                          positionCenter: false,
                          showInscreen: true,
                        },
                        {
                          title: "Secondary Qty",
                          name: "target",
                          placeHolder: "Enter Target",
                          textFieldError: "targetErr",
                          positionCenter: false,
                          showInscreen: true,
                        },
                        {
                          title: "Total Qty",
                          name: "target",
                          placeHolder: "Enter Target",
                          textFieldError: "targetErr",
                          positionCenter: false,
                          showInscreen: true,
                        },
                        {
                          title: "Total",
                          name: "name",
                          positionCenter: false,
                          showInscreen: true,
                          alignCenter: "left",
                        },
                      ]}
                      data={this.getFilteredTableData(
                        catData.productWithMarginAndMrps
                      )}
                      rowList={category.category}
                      setList={this.setCatList}
                      flag={stockFlag}
                    />
                  </TabPanel>
                );
              })}
              <br />
              <DynamicDetails
                DataToSet={[
                  {
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    label: "Total",
                    value: total.toFixed(2),
                  },
                  {
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    label: "Total Quantity",
                    value: totalOfQty,
                  },
                ]}
              />

              <Grid container spacing={1}>
                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  sx={{ justifyContent: "flex-end" }}
                >
                  <ButtonCompo
                    size="medium"
                    type="submit"
                    variant="contained"
                    name={"Submit"}
                    onClick={this.submitHandler}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  stockHolderList: state.stackholder,
  driverList: state.salesExecutive,
  category: state.category,
  beatList: state.beat,
  vehicleList: state.vehicle,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getRegionNew,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getStateByRegion,
  getAreaByUserType,
  getSalesExecutiveByAreaId,
  getBeatBySalesTeamIdAndAreaIdPost,
  getAreaByTalukaPostBody,
  getStockholderByAreaIdsForFilter,
  getDriversByStockHolderId,
  setCategoryAndItemForChallan,
  getSelfAssignedOrNotAssignedOverallVehicleAndBeats,
  getSelfAssignedOrNotAssignedOverallVehicleAndBeatsNew,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ChallanForm);
